module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"select-file":"Выберите файл","replace-the-file":"Замените файл","or-drag-it-here":"или перетащите его сюда"},"en":{"select-file":"Select file","replace-the-file":"Replace the file","or-drag-it-here":"or drag it here"}}')
  delete Component.options._Ctor
}
